<template>
  <v-btn
    color="primary"
    class="text-label-large"
    prepend-icon="mdi-refresh"
    variant="flat"
    @click="emit('refresh-clicked')"
  >
    Refresh
  </v-btn>
</template>

<script lang="ts" setup>
type Emits = {
  'refresh-clicked': [];
};
const emit = defineEmits<Emits>();
</script>
